import { render, staticRenderFns } from "./TypographyDropdown.vue?vue&type=template&id=05f06fea&scoped=true&"
import script from "./TypographyDropdown.vue?vue&type=script&lang=js&"
export * from "./TypographyDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TypographyDropdown.vue?vue&type=style&index=0&id=05f06fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f06fea",
  null
  
)

export default component.exports